import React from 'react';
import {ComponentLoader,GeneralLoader} from '../components/kit/loader'
import ErrorMessage from '../components/kit/modals/errorMessage';


function WithLoading(Component) {
  return function WihLoadingComponent({ isError, isLoading, isLayout, endPoint, handleClick, ...props }) {
    if (isLoading) return (
        isLayout ? <GeneralLoader/> : <ComponentLoader/>
    );
    if (isError) return (<ErrorMessage handleClick={handleClick} endPoint={endPoint} />);
    return (
    <Component {...props} />);
  }
}
export default WithLoading;